import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'
import { api } from './api.ts'

/** Primeiro segmento da rota -> nome legivel da funcionalidade (Console). */
const LABELS: Record<string, string> = {
  '': 'Início',
  home: 'Início',
  'work-items': 'Itens de Trabalho',
  kanbans: 'Quadros',
  portfolio: 'Portfólio',
  apps: 'Aplicações',
  companies: 'Empresas',
  people: 'Pessoas',
  admin: 'Administração',
  console: 'Console',
  profile: 'Perfil',
  status: 'Status',
  notifications: 'Notificações',
  calendar: 'Agenda',
  docs: 'Documentos',
  chat: 'Chat',
  channels: 'Canais',
  groups: 'Grupos',
  meetings: 'Reuniões',
  mail: 'E-mail',
  automations: 'Automações',
  broadcast: 'Comunicados',
}

function featureDaRota(pathname: string): string {
  const seg = pathname.split('/').filter(Boolean)[0] ?? ''
  return LABELS[seg] ?? (seg || 'Início')
}

/**
 * Registra no servidor a navegacao para uma FUNCIONALIDADE, para o dashboard
 * do Console. Dispara so quando a funcionalidade muda (nao a cada sub-rota), e
 * e fire-and-forget — nunca bloqueia navegacao nem quebra a UI se falhar.
 */
export function useAccessTracker() {
  const { pathname } = useLocation()
  const ultimo = useRef<string | null>(null)
  useEffect(() => {
    if (!api.isAuthenticated) return
    const feature = featureDaRota(pathname)
    if (feature === ultimo.current) return
    ultimo.current = feature
    void api.telemetry.access.$post({ json: { feature } }).catch(() => {})
  }, [pathname])
}
